import { CompetitionCategoryType } from "./CompetitionCategoryType.js";

export const competitionCategoryTypesWithRequiredAudio: CompetitionCategoryType[] = [
	CompetitionCategoryType.FreestyleStarters,
	CompetitionCategoryType.FreestyleOpen,
];
